import { h } from 'vue';
import type { VNodeChild } from 'vue';

// On the server, when a caller supplies `prerenderedHTML`, emit a declarative
// shadow-DOM `<template shadowrootmode="open">` alongside the light-DOM slot
// children so the diff paints before hydration. In the browser this is a no-op
// (the imperative core builds the shadow root itself). Mirrors the React
// adapter's `templateRender`.
export function templateRender(
  children: VNodeChild[],
  prerenderedHTML: string | undefined
): VNodeChild[] {
  if (typeof window === 'undefined' && prerenderedHTML != null) {
    return [
      h('template', { shadowrootmode: 'open', innerHTML: prerenderedHTML }),
      ...children,
    ];
  }
  return children;
}
